let toastKey = 13;
function sendToast (type, text) {

    let toaster = document.getElementById('acp-toasts');
    let  icon ='';
    toastKey++;
    switch (type) {
        case 'danger':
        case 'warning': icon = 'fa fa-exclamation'; break;

        case 'success':icon = 'ti-check'; break;
        case 'primary': icon = 'fa fa-info'; break;

        case 'super':
        case 'radiant': icon = 'ti-info-alt'; break;
    }

    toaster?.dispatchEvent(new CustomEvent("toast" , {detail:{key:toastKey, type,text,icon}} ));
}



export default {
    sendToast,
    sendToastDanger: (text)=>{sendToast('danger', text)},
    sendToastSuccess: (text)=>{sendToast('success', text)}
  }